import _objectSpread from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, Menu, TextField, Tooltip } from '@material-ui/core';
import PlusIcon from 'mdi-react/PlusIcon';
import DeleteOutlineIcon from 'mdi-react/DeleteOutlineIcon';
import SettingsOutlineIcon from 'mdi-react/SettingsOutlineIcon';
import isEqual from 'lodash/isEqual';

var GridToolbarSettings =
/*#__PURE__*/
function (_React$Component) {
  _inherits(GridToolbarSettings, _React$Component);

  function GridToolbarSettings() {
    var _this;

    _classCallCheck(this, GridToolbarSettings);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GridToolbarSettings).apply(this, arguments));
    _this.state = {
      open: null,
      modal: false,
      input: ''
    };

    _this.openMenu = function (event) {
      _this.setState({
        open: event.currentTarget
      });
    };

    _this.closeMenu = function () {
      _this.setState({
        open: null
      });
    };

    _this.openModal = function () {
      _this.setState({
        modal: true
      });
    };

    _this.closeModal = function () {
      _this.setState({
        modal: false,
        input: ''
      });
    };

    _this.onChange = function (event) {
      _this.setState({
        input: event.target.value
      });
    };
    /**
     * Сохранить фильтр
     */


    _this.saveSettings = function () {
      var input = _this.state.input;
      var _this$props = _this.props,
          columns = _this$props.columns,
          order = _this$props.order,
          rowsPerPage = _this$props.rowsPerPage,
          listSettings = _this$props.listSettings,
          onChangeListSettings = _this$props.onChangeListSettings;
      var newColumns = columns.map(function (column) {
        return {
          field: column.field,
          width: column.width,
          hide: !!column.hide
        };
      });
      listSettings.push({
        name: input,
        columns: newColumns,
        order: Array.isArray(order) ? order.map(function (_order) {
          return _objectSpread({}, _order);
        }) : undefined,
        rowsPerPage: rowsPerPage
      });
      onChangeListSettings(listSettings);

      _this.closeModal();
    };
    /**
     * Удалить фильтр
     * @param index
     */


    _this.deleteFilter = function (index) {
      return function () {
        var _this$props2 = _this.props,
            listSettings = _this$props2.listSettings,
            onChangeListSettings = _this$props2.onChangeListSettings;
        listSettings.splice(index, 1);
        onChangeListSettings(listSettings);
      };
    };

    _this.selectFilter = function (index) {
      return function () {
        var _this$props3 = _this.props,
            listSettings = _this$props3.listSettings,
            onChangeSettingsFromStorage = _this$props3.onChangeSettingsFromStorage;
        onChangeSettingsFromStorage(listSettings[index]);

        _this.closeMenu();
      };
    };

    _this.resetSettings = function () {
      _this.props.onResetSettings();

      _this.closeMenu();
    };

    _this.isActive = function (item) {
      var _this$props4 = _this.props,
          columns = _this$props4.columns,
          order = _this$props4.order;
      var copyColumns = columns.map(function (column, index) {
        return {
          field: column.field,
          width: column.width,
          hide: column.hide,
          index: index
        };
      });
      return isEqual(item.columns, copyColumns) && isEqual(item.order, order);
    };

    return _this;
  }

  _createClass(GridToolbarSettings, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          classes = _this$props5.classes,
          listSettings = _this$props5.listSettings;
      var _this$state = this.state,
          open = _this$state.open,
          modal = _this$state.modal,
          input = _this$state.input;
      return React.createElement(React.Fragment, null, React.createElement(Tooltip, {
        title: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438",
        disableFocusListener: true,
        disableTouchListener: true
      }, React.createElement(IconButton, {
        className: classes.toolbarActionButton,
        color: 'inherit',
        size: 'small',
        onClick: this.openMenu
      }, React.createElement(SettingsOutlineIcon, {
        size: 20
      }))), React.createElement(Menu, {
        anchorEl: open,
        open: Boolean(open),
        getContentAnchorEl: null,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'center'
        },
        onClose: this.closeMenu
      }, React.createElement("div", {
        className: classes.toolbarMenu
      }, React.createElement("div", {
        className: classes.toolbarMenuHead
      }, React.createElement("div", null, "\u041F\u0440\u0435\u0441\u0435\u0442\u044B \u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A"), React.createElement(Tooltip, {
        title: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C",
        disableFocusListener: true,
        disableTouchListener: true
      }, React.createElement(IconButton, {
        className: classes.toolbarMenuHeadPlus,
        color: 'primary',
        onClick: this.openModal
      }, React.createElement(PlusIcon, {
        size: 18
      })))), React.createElement(List, null, !listSettings.length && React.createElement("div", {
        className: classes.toolbarMenuEmpty
      }, "\u0421\u043F\u0438\u0441\u043E\u043A \u043F\u0443\u0441\u0442"), listSettings.map(function (filter, index) {
        var active = _this2.isActive(filter);

        return React.createElement(ListItem, {
          button: true,
          key: "filter-".concat(index),
          onClick: _this2.selectFilter(index),
          dense: true,
          className: "".concat(active ? classes.toolbarMenuActive : '')
        }, React.createElement(ListItemText, {
          primary: filter.name
        }), React.createElement(ListItemSecondaryAction, null, React.createElement(IconButton, {
          onClick: _this2.deleteFilter(index),
          size: 'small',
          className: "".concat(classes.toolbarMenuIcon, " ").concat(active ? classes.toolbarMenuIconActive : '')
        }, React.createElement(DeleteOutlineIcon, {
          size: 18
        }))));
      })), React.createElement("div", {
        className: classes.toolbarMenuBoot
      }, React.createElement("div", {
        className: classes.toolbarMenuBootButton,
        onClick: this.resetSettings
      }, "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438")))), React.createElement(Dialog, {
        open: modal,
        onClose: this.closeModal,
        "aria-labelledby": 'form-dialog-title',
        fullWidth: true,
        maxWidth: 'xs'
      }, React.createElement(DialogTitle, {
        id: 'form-dialog-title'
      }, "\u041D\u043E\u0432\u044B\u0439 \u043F\u0440\u0435\u0441\u0435\u0442 \u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A"), React.createElement(DialogContent, null, React.createElement(TextField, {
        autoFocus: true,
        margin: 'dense',
        label: "\u041D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435",
        type: 'text',
        value: input || '',
        onChange: this.onChange,
        fullWidth: true
      })), React.createElement(DialogActions, {
        className: classes.modalActions
      }, React.createElement(Button, {
        onClick: this.closeModal,
        color: 'default',
        variant: 'contained',
        size: 'small'
      }, "\u041E\u0442\u043C\u0435\u043D\u0430"), React.createElement(Button, {
        onClick: this.saveSettings,
        color: 'primary',
        size: 'small',
        variant: 'contained',
        disabled: !input
      }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"))));
    }
  }]);

  return GridToolbarSettings;
}(React.Component);

export default GridToolbarSettings;